import '../../Styles/ReusableComponents/header.scss';

function Header(props) {
  return (
    <div className="header">
      {props.headingRegular && <h1 className='headingRegular'>{props.headingRegular}</h1>}
      {props.headingLarge && <h1 className='headingLarge'>{props.headingLarge}</h1>}
      {props.headingHome && <h1 className='headingHome'>{props.headingHome}</h1>}
      {props.bodyText && <p className='bodyText'>{props.bodyText}</p>}
      {props.children}
    </div>
  )
}

export default Header